import { icons } from 'src/assets/iconDef/icon.def';

export const myBillsMenuDef = [
    {
        "view": "patient_bill",
        "showMenu": true,
        name: 'menu.my_bills',
        icon: 'fa fa-calendar',
        resource: 'patient_bill',
        url: 'patient_bill',
        auto_crud: true,
        breadcrumb: 'My Bills'
    },
    {
        "view": "patient_bill_kiosk",
        "showMenu": true,
        name: 'menu.my_bills',
        icon: 'fa fa-calendar',
        resource: 'patient_bill_kiosk',
        url: 'patient_bill_kiosk',
        auto_crud: true,
        breadcrumb: 'My Bills'
    }
]